import { IconTag } from '@tryhackme/thm-ui-components';
import { faCircleSmall } from '@fortawesome/pro-solid-svg-icons';
import { faBoltLightning, faTag, faMinusCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { BaseUserProps } from 'src/features/admin/manage-users/components/user/user.types';
import { StyledTagIcon, StyledTagsItem, StyledTagsItemText } from './tags.styles';
export const Tags = ({
  user
}: BaseUserProps) => <>
    {user.trialAccount && <StyledTagsItem>
        <IconTag type="warning" fullWidth>
          <StyledTagIcon icon={faTag} $color="warning" /> Trial account
        </IconTag>
      </StyledTagsItem>}
    <StyledTagsItem data-sentry-element="StyledTagsItem" data-sentry-source-file="tags.tsx">
      <StyledTagsItemText data-sentry-element="StyledTagsItemText" data-sentry-source-file="tags.tsx">Level</StyledTagsItemText>
      <IconTag type="neutral" data-sentry-element="IconTag" data-sentry-source-file="tags.tsx">
        <StyledTagIcon icon={faBoltLightning} $color="info" data-sentry-element="StyledTagIcon" data-sentry-source-file="tags.tsx" /> {user.level}
      </IconTag>
    </StyledTagsItem>
    <StyledTagsItem data-sentry-element="StyledTagsItem" data-sentry-source-file="tags.tsx">
      <StyledTagsItemText data-sentry-element="StyledTagsItemText" data-sentry-source-file="tags.tsx">Account status</StyledTagsItemText>
      <IconTag type={user.banned ? 'error' : 'success'} data-sentry-element="IconTag" data-sentry-source-file="tags.tsx">
        <StyledTagIcon icon={faCircleSmall} $color={user.banned ? 'error' : 'success'} data-sentry-element="StyledTagIcon" data-sentry-source-file="tags.tsx" />
        {user.banned ? <>Banned</> : <>Active</>}
      </IconTag>
    </StyledTagsItem>
    <StyledTagsItem data-sentry-element="StyledTagsItem" data-sentry-source-file="tags.tsx">
      <StyledTagsItemText data-sentry-element="StyledTagsItemText" data-sentry-source-file="tags.tsx">Subscription</StyledTagsItemText>
      <IconTag type={user.subscriptionActive ? 'info' : 'neutral'} data-sentry-element="IconTag" data-sentry-source-file="tags.tsx">
        {user.subscriptionActive ? <>
            <StyledTagIcon icon={faCheckCircle} />
            Subscribed
          </> : <>
            <StyledTagIcon icon={faMinusCircle} />
            Not subscribed
          </>}
      </IconTag>
    </StyledTagsItem>
  </>;